import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {StockApi} from './stock.api';
import {finalize} from 'rxjs/operators';
import {Stock} from './stock';
import {ListFilter, ListResult, Pagination} from "@shared/base";
import {StockGroup} from "@app/stock/shared/stock-group";

export class StockDataSource implements DataSource<Stock> {
  private _subject = new BehaviorSubject<Stock[]>([]);
  private _loading = new BehaviorSubject<boolean>(false);

  private _listResult = new BehaviorSubject<ListResult<Stock>>(new ListResult<Stock>());
  stockGroupList: StockGroup[];

  constructor(private stockApi: StockApi) {
  }

  public get loading(): Observable<boolean> {
    return this._loading.asObservable();
  }

  public get records(): number {
    return this._listResult.getValue().records;
  }

  connect(_collectionViewer: CollectionViewer): Observable<Stock[]> {
    return this._subject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this._subject.complete();
    this._loading.complete();
  }

  loadStock(filter: ListFilter, pagination: Pagination) {
    this._loading.next(true);

    this.stockApi.findByFilter(filter, pagination).pipe(
      // catchError(() => of([])),
      finalize(() => this._loading.next(false))
    ).subscribe(listResult => {
      if(this.stockGroupList?.length > 0) {
        listResult.data.forEach(value => {
          value.stockGroup = this.stockGroupList.find(s => s.id === value.groupId).name;
        })
      }

      this._listResult.next(listResult);
      this._subject.next(listResult.data);
    });
  }
}
